var map = {
	"./NotFound.svg": "84af",
	"./Others.svg": "3665",
	"./Pos.svg": "b52a",
	"./QRIS_logo.svg": "8000",
	"./RoomService.svg": "a673",
	"./bar-bill-active.svg": "e464",
	"./bar-bill.svg": "253d",
	"./bar-order-active.svg": "dad8",
	"./bar-order.svg": "ab41",
	"./cart.svg": "6f5d",
	"./changeTable.svg": "4f58",
	"./checked_checkbox.svg": "9a52",
	"./checked_circle.svg": "dc46",
	"./customers.svg": "4908",
	"./dana-icon.svg": "b094",
	"./delete.svg": "d739",
	"./delivery.svg": "d3e9",
	"./dineIn.svg": "d82b",
	"./error.svg": "2ee5",
	"./exclamation.svg": "89ca",
	"./eye.svg": "83a4",
	"./info.svg": "07e6",
	"./laptop.svg": "4995",
	"./magnifying-glass.svg": "bf99",
	"./men.svg": "eccb",
	"./menActive.svg": "5a8c",
	"./menu.svg": "36be",
	"./meter.svg": "9fa4",
	"./moto.svg": "a1a7",
	"./no-coupon.svg": "9e82",
	"./no_data.svg": "0d78",
	"./orderStatus/accepted.svg": "a6f4",
	"./orderStatus/billCompleted.svg": "6751",
	"./orderStatus/blueWallet.svg": "7dd2",
	"./orderStatus/cancelled.svg": "b5c4",
	"./orderStatus/completed.svg": "c054",
	"./orderStatus/init.svg": "9f92",
	"./orderStatus/neworder.svg": "83d9",
	"./orderStatus/ondelivery.svg": "c161",
	"./orderStatus/open.svg": "ac99",
	"./orderStatus/prepared.svg": "52dd",
	"./orderStatus/preparing.svg": "b098",
	"./orderStatus/readtopickup.svg": "0468",
	"./orderStatus/search.svg": "9dda",
	"./orderStatus/stopWatch.svg": "d2be",
	"./orderStatus/submitted.svg": "dc22",
	"./orderStatus/transformed.svg": "c922",
	"./other-order.svg": "26ef",
	"./pos-order.svg": "700a",
	"./print.svg": "b883",
	"./print2.svg": "3029",
	"./prompt.svg": "a60c",
	"./refresh.svg": "b7d8",
	"./refreshActive.svg": "58c4",
	"./room.svg": "8ea5",
	"./search-icon.svg": "d8e7",
	"./search.svg": "51f2",
	"./shop.svg": "5cb7",
	"./sidebar-edc.svg": "eccc",
	"./sidebar.svg": "8070",
	"./success.svg": "2764",
	"./tableOrder.svg": "eac1",
	"./take-away.svg": "694a",
	"./takeAway.svg": "06c6",
	"./togglemenu.svg": "bd0b",
	"./upDownArrow.svg": "5c51",
	"./update-arrows.svg": "3381",
	"./user-edc.svg": "b3b5",
	"./user.svg": "0f62",
	"./whatsapp.svg": "3357",
	"./women.svg": "3dfb",
	"./womenActive.svg": "9a93",
	"./yuan-no.svg": "043d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";